import { buttonBaseStyles, getFocusStyles, getVariantStyles, sizeStyles, getWidthStyles, } from "../components/Button/styles";
export const buttonStyles = ({ variant, color = 'blue', size = 'medium', fullWidth = false, isSelected = false, }) => {
    return {
        ...buttonBaseStyles,
        ...getFocusStyles(color, variant),
        ...getWidthStyles(fullWidth),
        ...sizeStyles[size],
        ...getVariantStyles(variant, color, isSelected),
    };
};
